import { DocumentMode } from '@root/@types/types';

import type { TransitionConfigMap } from '../types';

export const PUBLISHED_TRANSITIONS: TransitionConfigMap = {
  DRAFT: {
    [DocumentMode.TEMPLATES]: () => ({
      title: 'Return to Draft state?',
      content:
        'Setting this template back to Draft will make it editable again. It must then be returned to Published before it can be used on a Contract.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
  },
  ARCHIVED: {
    [DocumentMode.TEMPLATES]: () => ({
      title: 'Archive template?',
      content:
        'Setting this template to Archived will take it out of active use. It must be returned to Draft to make it editable again.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, archive template' },
      },
      icon: { type: 'warning' },
    }),
  },
};
